<span class="twitter-share-button icon fab fa-twitter fa-lg" (click)="share()"></span>
